import axios from 'axios';
import API_BASE_URL from '../../../../config/apiConfig';

const API_URL = `${API_BASE_URL}/api/IACarePlan/generate`;

export const generateIACarePlan = async (patientData) => {
  console.log("[IA CarePlan] ▶ generateIACarePlan called");
  console.log("[IA CarePlan] API_BASE_URL:", API_BASE_URL);
  console.log("[IA CarePlan] Full URL:", API_URL);
  console.log("[IA CarePlan] Payload (patientData):", patientData);

  const token = localStorage.getItem("token");
  console.log("[IA CarePlan] Token present:", !!token, "length:", token?.length);

  try {
    const response = await axios.post(API_URL, patientData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    console.log("[IA CarePlan] ✓ Response status:", response.status);
    console.log("[IA CarePlan] ✓ Response data:", response.data);

    return response.data; // { resultado: "..." }
  } catch (error) {
    console.error("[IA CarePlan] ✗ ERROR generating care plan");
    console.error("[IA CarePlan] ✗ error.message:", error.message);
    console.error("[IA CarePlan] ✗ error.code:", error.code);
    console.error("[IA CarePlan] ✗ response.status:", error.response?.status);
    console.error("[IA CarePlan] ✗ response.statusText:", error.response?.statusText);
    console.error("[IA CarePlan] ✗ response.data:", error.response?.data);
    console.error("[IA CarePlan] ✗ response.headers:", error.response?.headers);
    console.error("[IA CarePlan] ✗ request config:", {
      url: error.config?.url,
      method: error.config?.method,
      headers: error.config?.headers,
      data: error.config?.data,
    });
    console.error("[IA CarePlan] ✗ full error object:", error);
    throw error;
  }
};